import { render, staticRenderFns } from "./Proformas.vue?vue&type=template&id=7f141916&scoped=true&"
import script from "./Proformas.vue?vue&type=script&lang=js&"
export * from "./Proformas.vue?vue&type=script&lang=js&"
import style0 from "./Proformas.vue?vue&type=style&index=0&id=7f141916&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f141916",
  null
  
)

export default component.exports